import {useState} from "react";
import {Link} from "react-router-dom";
import "./register.scss";
import {internalApi} from "../../common/axios";
import toast from "react-hot-toast";

const Register = () => {
    const [inputs, setInputs] = useState({
        id: "",
        email: "",
        password: "",
        name: "",
    });
    const [err] = useState(null);

    const handleChange = (e) => {
        setInputs((prev) => ({...prev, [e.target.name]: e.target.value}));
    };

    const handleRegister = async (e) => {
        e.preventDefault();

        // if (!areInputsValid()) {
        //   toast("모든 필드를 입력해주세요.");
        //   return;
        // }

        try {
            await internalApi.post('auth/register', inputs);
        } catch (err) {
            toast(err.response.data);
        }
    };

    return (
        <div className="register">
            <div className="card">
                <div className="right">

                </div>
                <div className="left">
                    <h1>Register</h1>
                    <form>
                        <input
                            type="text"
                            placeholder="id"
                            name="id"
                            onChange={handleChange}
                        />
                        <input
                            type="email"
                            placeholder="Email"
                            name="email"
                            onChange={handleChange}
                        />
                        <input
                            type="password"
                            placeholder="Password"
                            name="password"
                            onChange={handleChange}
                        />
                        <input
                            type="text"
                            placeholder="Name"
                            name="name"
                            onChange={handleChange}
                        />

                    </form>
                    {err && err}
                    <div className="buttons">
                        <button onClick={handleRegister}>Register</button>
                        <Link to="/login">
                            <button>Login</button>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Register;
